import defaultAxios from 'axios'
import Cookies from 'js-cookie'
import { API_ENDPOINTS, detectEnvironmentFromHostname } from 'src/utils/environmentConstants'

const API_URLS = {
  localhost: API_ENDPOINTS.localhost,
  dev: API_ENDPOINTS.dev,
  qa: API_ENDPOINTS.qa,
  qaDr: API_ENDPOINTS['qa-dr'],
  uat: API_ENDPOINTS.uat,
  prod: API_ENDPOINTS.production,
  prodDr: API_ENDPOINTS['prod-dr']
}

const resolveBaseUrlFromHostname = (hostnameOverride) => {
  const resolvedHostname = hostnameOverride || (typeof window !== 'undefined' ? window.location?.hostname : null)

  if (!resolvedHostname) {
    return null
  }

  const env = detectEnvironmentFromHostname(resolvedHostname)

  switch (env) {
    case 'production':
      return API_URLS.prod
    case 'prod-dr':
      return API_URLS.prodDr
    case 'qa':
      return API_URLS.qa
    case 'qa-dr':
      return API_URLS.qaDr
    case 'uat':
      return API_URLS.uat
    case 'localhost':
      return API_URLS.localhost
    case 'dev':
      return API_URLS.dev
    default:
      return API_URLS.dev
  }
}

const baseUrl = resolveBaseUrlFromHostname() || import.meta.env.VITE_API_BASE_URL || API_URLS.dev

const baseHeaders = {
  X_API_Tenant: 'evantaconnect',
  'Content-Type': 'application/json',
  X_API_Client: 'gcc-web'
}

// for login
// const unauthApi = defaultAxios.create({
//   baseURL: baseUrl,
//   withCredentials: false,
//   headers: baseHeaders
// })

const axios = defaultAxios.create({
  baseURL: baseUrl,
  headers: {
    ...baseHeaders,
    X_API_EMAIL: Cookies.get('email')
  },
  validateStatus: () => true
})

axios.interceptors.request.use(
  async (config) => {
    const token = Cookies.get('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

const fetchData = (path, params) => {
  const id = params?.eventId || ''
  const timestamp = params?.timestamp ? `/${params.timestamp}` : ''

  return axios.get(`${path}${id}${timestamp}`, { ...params })
    .then(response => response)
    .catch(error => error)
}

const postData = (path, params, config) => {
  return axios.post(`${path}`, JSON.stringify(params), { ...config })
    .then(response => response)
    .catch(error => error)
}

const putData = (path, params, config) => {
  return axios.put(`${path}`, JSON.stringify(params), { ...config })
    .then(response => response)
    .catch(error => error)
}

const deleteData = (path, config) => {
  return axios.delete(`${path}`, { ...config })
}

const postFile = async (path, params, header) => {
  const paramsToken = Cookies.get('token')
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
      X_API_EMAIL: Cookies.get('email'),
      Authorization: paramsToken,
      ...header
    }
  }
  return axios.post(`${path}`, params, config)
    .then(response => response)
    .catch(error => error)
}

export { axios, fetchData, postData, putData, postFile, deleteData, resolveBaseUrlFromHostname }
